import { FaEnvelope, FaMapMarkedAlt, FaPhoneAlt } from 'react-icons/fa';

const contacts = [  
    {
        id: 1, 
        icon: <FaPhoneAlt />,
        title: 'Zadzwoń do nas',
        content: [ '+48 507-699-197'],
    },
    {
        id: 2,
        icon: <FaEnvelope />,
        title: 'Wyślij email',
        content: [ 'info@dworimielno.com'],
    },
    {
        id: 3,
        icon: <FaMapMarkedAlt />,
        title: 'Ogród Dwór Imielno',
        content: ['Imielno 18 99-350 Ostrowy'],
    },
    {
        id: 4,
        icon: <FaPhoneAlt />,
        title: 'Sekretariat',
        content: ['+42 236 40 40'],
    },
    //   {
 //        id: 4,
 //        icon: <FaClock />,
 //        title: 'open timing',
 //        content: ['Mon - Fri: 7 AM - 7 PM', 'Sat - Sun: 8 AM - 6 PM'],
 //    },
 
];

export default contacts;